import { decodeURIComponentSafe } from 'helpers/BrowserHelpers';

import { getOpenGraphUrl, getPageSeoBreadcrumbs } from './SeoHelpers';

import type { ISearchPageUrlParams, PageSeoProps, TFunction } from 'types';

// TODO: i18n

export function getSearchPageSeoProps(t: TFunction, urlParams: ISearchPageUrlParams): PageSeoProps {
  const decodedKeyword = decodeURIComponentSafe(urlParams.identifier || '');
  return {
    seoProps: {
      title: `Cauți ${decodedKeyword} ?`,
      description: `Ai căutat ${decodedKeyword}, descoperă oferta Freshful.ro`,
      openGraph: {
        url: getOpenGraphUrl(),
        description: `Ai căutat ${decodedKeyword}, descoperă oferta Freshful.ro`,
      },
      noindex: true,
    },
    breadcrumbs: getPageSeoBreadcrumbs(t)
  };
}
